import { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { selectedTaskState,namespaceState } from '../../recoil/atoms';
import saveAs from 'file-saver';

import styles from './style.module.css';
import CircleProgressBar from './CircleProgressBar';
import RoundListRow from './RoundListRow';
import LineChart from './LineChart';
import DonutChart from './DonutChart';
import useApi from '../../services/useApi';
import axios from 'axios';
import getDuration from '../../utils/getDuration';
import { DEVICE_STATE_COLOR, DEVICE_STATE_NAME } from '../../constants';
import dateFormat from '../../utils/dateFormat';
import { useParams } from 'react-router-dom';
import Portal from '../../utils/Portal';
import toUpperFirstCase from '../../utils/toUpperFirstCase';
import HeatmapConfusion from './HeatmapConfusion';
import preprocessMatrixToData from '../../utils/preprocessMatrixtoData';
import BtnWithTip from '../../compoenets/BtnWithTip';
import checkChartNull from '../../utils/checkChartNull';

const ParticipateRow = ({title,devices,percent,color}) => {
  return(
     <>
       <div className={styles["info-light"]} style={{background:color}}></div>
       <div className={styles["info-title"]}>{DEVICE_STATE_NAME[title]}</div>
       <div className={styles["info-devices"]}>{devices}</div>
       <div className={styles["info-percent"]}>{isNaN(percent)?"0.00":percent}%</div>
     </>
  );
};

export default function TaskDetail() {
  const [selectedTask, setSelectedTask] = useRecoilState(selectedTaskState);
  const [taskData,setTaskData]=useState([]);
  const [taskDataLoading,setTaskDataLoading]=useState(false);
  const [roundData, setRoundData] = useState([]);
  const [roundDataLoading, setRoundDataLoading] = useState(false);
  const [roundTrainingIndex,setRoundTrainingIndex]=useState(0);
  const [testIndex,setTestIndex]=useState(0);
  const [isTest,setIsTest]=useState(false);

  const [toggleTotalboardMenu,setToggleTotalBoardMenu]= useState(0);
  const [toggleRoundboardMenu,setToggleRoundBoardMenu]= useState(0);
  const [scroll, setScroll] = useState(false);
  const [roundOn,setRoundOn]=useState(1);
  const [roundPercent,setRoundPercent]=useState(0);

  const [totalTrainLossData,setTotalTrainLossData]=useState();
  const [totalEvalLossData,setTotalEvalLossData]=useState();
  const [totalAccData,setTotalAccData]=useState();
  const [totalMaeData,setTotalMaeData]=useState();
  const [totalMseData,setTotalMseData]=useState();
  const [totalRmseData,setTotalRmseData]=useState();
  const [totalEpsilonMinData,setTotalEpsilonMinData]=useState();
  const [totalEpsilonMaxData,setTotalEpsilonMaxData]=useState();
  const [totalEpsilonAvgData,setTotalEpsilonAvgData]=useState();
  const totalChartWidth='280';

  const [deviceDataOld,setDeviceDataOld]=useState([]);
  const [deviceState,setDeviceState]=useState(null);
  const [jobType,setJobType]=useState("TRAINING");
  const [jobTypeOld,setJobTypeOld]=useState("");

  const [apiCountTask,setApiCountTask]=useState(0)
  const [apiCountDevice,setApiCountDevice]=useState(0)

  const [donutData,setDonutData]=useState(null);

  const [isConfigModal,setIsConfigModal]=useState(false);

  const [modelType,setModelType]=useState("");

  const [confusionData,setConfusionData]=useState(null);

  const [isLinkCopy,setIsLinkCopy]=useState(false);
  const [isConfusionDownload,setIsConfusionDownload]=useState(false);

  const cancelToken = axios.CancelToken;
  let cancelApi = cancelToken.source();
  const urlParams=useParams();
  const taskId = urlParams.taskId?urlParams.taskId:selectedTask.taskId;
  const [nsState,setNsState]=useRecoilState(namespaceState);

  const getTaskDetailData=(newRoundOn=roundOn,newJobType=jobType)=>{
    setApiCountTask(0);
    setApiCountDevice(0);
    useApi.get("/ngp/fl/task/"+taskId+"/rounds?includeTask=True&namespaceId="+nsState.id).then((res)=>{
      setSelectedTask(res.data)
      setTaskData(res.data);
      setTaskDataLoading(true);
      setApiCountTask(1);
      getRoundData(res.data,res.data.rounds);
      setModelType(JSON.parse(res.data.recipe.hyperparameter).modelType)
      if(res.data.recipe.requiredData!=='emnist')return;
      if(JSON.parse(res.data.recipe.hyperparameter).modelType==="classification"){
        if(res.data.rounds.some(item=>item.roundNum===newRoundOn&&item.state==='COMPLETED')){
          useApi.get('ngp/modelreg/mm/model/v1/task/modelmetric?namespaceId='+nsState.id+'&taskId='+taskId+'&roundNum='+newRoundOn)
          .then(res=>{
              setConfusionData(preprocessMatrixToData(res.data))
          })
          .catch(err=>{
            setConfusionData(null)
          })
        }
      }
    });

    useApi.get("/ngp/fl/results/deviceStateCount?taskId="+taskId+"&roundNum="+newRoundOn+"&jobType="+newJobType+"&namespaceId="+nsState.id,{
      cancelToken: cancelApi.token
    }).then((res)=>{
      setDeviceState(Object.entries(res.data).map(([key,value])=>({status:key,value,})).filter(item=>item.value!==false&&item.value!==true));
      setApiCountDevice(1);
    })
    .catch(function (thrown) {
      if (axios.isCancel(thrown)) {
        // console.log('Request canceled', thrown.message);
      } else {
      }
    });
  }

  const getRoundData=(newTaskData,newRoundData)=>{

    let updatedRoundData={};
    for(var i=1;i<=newTaskData.recipe.maxRound ;i++){
      updatedRoundData[i]={
        "roundNum":i,
        "taskId":newTaskData.taskId,
        "distributionModelId":null,
        "aggregationModelId": null,
        "createdTime": null,
        "updatedTime": null,
        "state": null,
        "errorReason": null,
        "trainingResult": null,
        "evaluationResult": null,
        "testResult": null
      };
    }
    if(newTaskData.recipe.numOfTargetTestRequestDevices>0&&newTaskData.recipe.numOfTargetTestRequestDevices!=null){
      updatedRoundData[newTaskData.recipe.maxRound+1]={"roundNum":newTaskData.recipe.maxRound+1}
    }

    newRoundData.map((data)=>{
      updatedRoundData[data.roundNum]=data;
      if(data.state=="TRAINING" || data.state=="EVALUATION"|| data.state=="TEST" || data.state=="FAILED") {
        if(!roundDataLoading){
          setRoundOn(data.roundNum);
        }
        setRoundTrainingIndex(data.roundNum-1);
      };
    })

    setRoundData(updatedRoundData);
    
    setRoundPercent(()=>{
      let newRoundPercent=0;
      newRoundData.map((item)=>{
        switch(item.state){
          case "TRAINING":
            newRoundPercent+=0.3;
            break;
          case "EVALUATION":
            newRoundPercent+=0.6;
            break;
          case "TEST":
            newRoundPercent+=0.6;
            break;
          case "COMPLETED":
            newRoundPercent+=1;
            break;
        }
      })
      return newRoundPercent;
    })
    if(newTaskData.taskState=="COMPLETED"){
      if(newTaskData.recipe.numOfTargetTestRequestDevices==0){
        setRoundTrainingIndex(newTaskData.recipe.maxRound);
      }
      else{
        setRoundTrainingIndex(newTaskData.recipe.maxRound+1);
      }
    }

    setTotalTrainLossData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.trainingResult)return null;
          return{
            x:item.roundNum,
            y:item.trainingResult?item.trainingResult.outputs.loss:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalEvalLossData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return{
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.loss:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalAccData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.accuracy:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalMaeData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.mae:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalMseData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.mse:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })
    setTotalRmseData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.evaluationResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.evaluationResult.outputs.rmse:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalEpsilonMinData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.trainingResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.trainingResult.epsilon?.min:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalEpsilonMaxData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.trainingResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.trainingResult.epsilon?.max:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })

    setTotalEpsilonAvgData(()=>{
      const newData=newRoundData.map((item,index)=>{
        if(index<newTaskData.recipe.maxRound){
          if(!item.trainingResult)return null;
          return {
            x:item.roundNum,
            y:item.evaluationResult?item.trainingResult.epsilon?.avg:null
        }}
        else{
          return null
        }
      }).filter((item) => item !== null);
      return newData;
    })


    setRoundDataLoading(true);
  }

  useEffect(() => {
    getTaskDetailData()
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(()=>{
    // console.log("check api",apiCountTask,apiCountDevice);
    if(apiCountTask==1&&apiCountDevice==1){
      // console.log("done api",apiCountTask,apiCountDevice);
      const setTimeOutId=setTimeout(() => {
        // console.log("api setTime")
        cancelApi = cancelToken.source();
        getTaskDetailData();
      }, 3000);
      return ()=>{clearTimeout(setTimeOutId)};
    };
  },[apiCountTask,apiCountDevice])

  // useInterval(()=>{
  //   getTaskDetailData();
  // },1000)

  useEffect(()=>{
    if(!deviceState)return;
    if(
      (JSON.stringify(deviceState)===JSON.stringify(deviceDataOld))
      &&(jobType===jobTypeOld)
    )return;
    else{
      setDeviceDataOld(deviceState);
      setJobTypeOld(jobType);
    }

    const statusMap = {
      TRAINING: ['evaluation', 'test'],
      EVALUATION: ['training', 'test'],
      TEST: ['training', 'evaluation'],
    };
    const toRemove = statusMap[jobType];
    const newDonutData =deviceState.filter(item => !toRemove.includes(item.status));
    setDonutData(newDonutData);
  },[deviceState,isTest,roundOn,toggleRoundboardMenu])

  useEffect(()=>{
    if(!roundDataLoading)return;
    if(taskData.recipe.numOfTargetTestRequestDevices!=0){
      if(Object.keys(roundData).length===1){
        setTestIndex(1);
      }
      else{
        setTestIndex(Object.keys(roundData).length);
      }
      setIsTest(true);
    }
  },[roundData]);

  const handleScroll = () => {
    if(window.scrollY >= 50 && scroll==false){
      setScroll(true);
    }
    else if(window.scrollY >= 50 && scroll!=false){

    }
    else{
      setScroll(false);
    }
  };

  useEffect(()=>{
    if(taskData.length==0)return;
    let newJobType
    // if(!taskData.recipe){
    //   setJobType("TEST")
    //   newJobType="TEST"
    // }
    if(isTest && roundOn==testIndex) {
      setJobType("TEST")
      newJobType="TEST"
    }
    else if(toggleRoundboardMenu==0){
      setJobType("TRAINING")
      newJobType="TRAINING"
    }
    else if(toggleRoundboardMenu==1){
      setJobType("EVALUATION")
      newJobType="EVALUATION"
    }

    cancelApi.cancel("Api Cancel");
    cancelApi = cancelToken.source();
    getTaskDetailData(roundOn,newJobType);

  },[isTest,roundOn,toggleRoundboardMenu])

  const handleDebug=()=>{
    window.open(`http://debug-${process.env.REACT_APP_ENV}kr.aip-cloud.com/flpoc/debug-extra.html?taskId=${taskData.taskId}`, "_blank", "noopener, noreferrer");
  }

  const handleLog=()=>{
    window.open(`http://device-farm-${process.env.REACT_APP_ENV}kr.ngpdev.com:3001/dump/fl-tasks/${taskData.taskId}`)
  }

  const handleShare=()=>{
    navigator.clipboard.writeText(`https://wsfe-`+process.env.REACT_APP_ENV+`kr.ngpdev.com/`+taskData.taskId)
    .then(()=>{
      setIsLinkCopy(true)
      setTimeout(() => {
          setIsLinkCopy(false);
      }, 1000);
    })
    .catch(err=>console.error('copy fail:',err))
  }

  const handleModalOutside=(e)=>{
    if(isConfigModal&&!e.target.closest(`.${styles['modal-config-main']}`)){
      setIsConfigModal(false)
    }
  }

  const handleConfusionDownload=()=>{
    useApi.get('/ngp/modelreg/mm/model/v1/task/matrix/download?namespaceId='+nsState.id+'&taskId='+taskId+'&roundNum='+roundOn
    ,{ responseType: 'blob'})
    .then((res)=>{
        saveAs(res.data, "taskId"+
        taskId.split("-")[0]+
        "_"+
        (roundOn!=testIndex?"roundNum"+String(roundOn).padStart(2,'0'):"roundTest") + 
        ".csv");

        setIsConfusionDownload(true)
        setTimeout(() => {
            setIsConfusionDownload(false);
        }, 1000);
    });
  }

  const handleDownloadMetric = () => {
    const metricsSet = new Set();
    taskData.rounds.forEach(item => {
      ['trainingResult', 'evaluationResult', 'testResult'].forEach(resultKey => {
        const outputs = item[resultKey]?.outputs;
        if (outputs) {
          Object.keys(outputs).forEach(metric => metricsSet.add(`${resultKey}.${metric}`));
        }
      });
    });
    const taskInfo = ['task ID',taskData.taskId, 'Task Name:',taskData.taskName].join(',');
    const headers = ['roundNum', ...Array.from(metricsSet),,taskInfo];

    const rows = taskData.rounds.map(item => {
      const row = [item.roundNum];
      headers.slice(1).forEach(metricKey => {
        const [resultKey, metric] = metricKey.split('.');
        row.push(item[resultKey]?.outputs?.[metric] ?? '');
      });
      return row;
    });

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'metric_data_'+taskData.taskId+'.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <>
    {/* <Header title={selectedTask.taskName} scrolled={scroll}></Header> */}
      <div className={styles["TaskDetail-wrap"]}>
        <div className={styles["TaskDetail-header"]}>
          <span>{selectedTask.taskName}</span>
          <div className={styles["header-btn-wrap"]}>
            <BtnWithTip 
            className={`${styles['header-btn-link']} ${styles['header-btn-metric']}`} 
            onClick={handleDownloadMetric}
            defaultText={"Download Metric Data"}
            />
            <BtnWithTip 
            className={`${styles['header-btn-link']} ${styles['header-btn-share']}`} 
            onClick={handleShare}
            defaultText={"Copy Link"}
            changeText={isLinkCopy&&"Copy Done"}
            />
            {taskData.taskName && taskData.taskName.includes("farm") && 
              <BtnWithTip 
              className={`${styles['header-btn-link']} ${styles['header-btn-log']}`} 
              onClick={handleLog}
              defaultText={"Dump Log"}
              />
            }
            <BtnWithTip 
            className={`${styles['header-btn-link']} ${styles['header-btn-debug']}`} 
            onClick={handleDebug}
            defaultText={"Debug Page"}
            />
          </div>
        </div>
        <div className={styles["TaskDetail-body"]}>
          <div className={styles["TaskDetail-rounds"]}>
            <div className={styles["rounds-status"]}>
              <span> {taskDataLoading && toUpperFirstCase(taskData.taskState)}</span>
              <span> {Object.keys(roundData).length!=0 && (
                taskData.taskState=="COMPLETED"?
                getDuration(roundData[1].createdTime,roundData[Object.keys(roundData).length].updatedTime):
                roundTrainingIndex +" round / "+ (taskData.recipe.maxRound) + " round" + (taskData.recipe.numOfTargetTestRequestDevices!=0? " + Test":"")
                )}</span>
              {Object.entries(taskData).length!=0&&
              (taskData.recipe.numOfTargetTestRequestDevices!=0?
              <CircleProgressBar percentage={(roundPercent/(taskData.recipe.maxRound+1))*100} strokeWidth={10} sqSize={100} color="#79D2DE" />
              :
              <CircleProgressBar percentage={(roundPercent/taskData.recipe.maxRound)*100} strokeWidth={10} sqSize={100} color="#79D2DE" />)}
            </div>
            <div className={styles["rounds-list"]}>
              {roundDataLoading &&
              <>
              {Object.entries(roundData).map(([key,value])=>
              // (Object.entries(roundData).length==key && isTest) ?
              (Object.entries(roundData).length>key &&
              <RoundListRow index={value.roundNum} row={value} onClickChange={()=>setRoundOn(value.roundNum)} roundOn={roundOn}></RoundListRow>
              )
              )}
              {!isTest&&
              <RoundListRow index={Object.entries(roundData).pop()[1].roundNum} 
              row={Object.entries(roundData).pop()[1]} onClickChange={()=>setRoundOn(Object.entries(roundData).pop()[1].roundNum)} 
              roundOn={roundOn}></RoundListRow>
              }
              </>}
              
            </div>
            
            {roundDataLoading &&
            (isTest &&
            <div className={styles["rounds-list-test"]}>
              <hr></hr>
              <RoundListRow index={Object.entries(roundData).pop()[1].roundNum} 
              row={Object.entries(roundData).pop()[1]} onClickChange={()=>setRoundOn(Object.entries(roundData).pop()[1].roundNum)} 
              testIndex={testIndex} 
              roundOn={roundOn}></RoundListRow>
            </div>
            )}
          </div>
          <div className={styles["TaskDetail-totalBoard"]}>
            <div className={styles["totalBoard-header"]}>
              <span>Total Dashboard
                {toggleTotalboardMenu==1&&<div 
                className={styles["totalBoard-header-config-link"]}
                onClick={()=>setIsConfigModal(true)}
                >
                  <BtnWithTip 
                  className={styles["totalBoard-header-config-tip"]} 
                  defaultText={"Expand Config"}
                  pos='right'
                  />
                </div>}
              </span>
              <div className={styles["totalBoard-header-menu"]}>
                <div className={`${styles["totalBoard-header-border"]} ${toggleTotalboardMenu == 0 ? styles["totalBoard-header-border-left"] : styles["totalBoard-header-border-right"]}`}></div>
                <span className={`${styles["totalBoard-header-menu-span"]} ${toggleTotalboardMenu==0 && styles["totalBoard-header-menu-on"]}`} onClick={()=>{setToggleTotalBoardMenu(0)}}>Metric</span>
                <span className={`${styles["totalBoard-header-menu-span"]} ${toggleTotalboardMenu==1 && styles["totalBoard-header-menu-on"]}`} onClick={()=>{setToggleTotalBoardMenu(1)}}>Configuration</span>
              </div>
            </div>
            <div className={`${styles["totalBoard-body"]} ${toggleTotalboardMenu==1&&styles['totalBoard-body-chart']}`}>
            {!checkChartNull(totalTrainLossData)&&<LineChart 
              chartData={totalTrainLossData} 
              xAxisLabel="Round" 
              yAxisLabel="Train Loss" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalEvalLossData)&&<LineChart 
              chartData={totalEvalLossData} 
              xAxisLabel="Round" 
              yAxisLabel="Evaluation Loss" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalAccData)&&<LineChart 
              chartData={totalAccData} 
              xAxisLabel="Round" 
              yAxisLabel="Accuracy" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalMaeData)&&<LineChart 
              chartData={totalMaeData} 
              xAxisLabel="Round" 
              yAxisLabel="MAE" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalMseData)&&<LineChart 
              chartData={totalMseData} 
              xAxisLabel="Round" 
              yAxisLabel="MSE" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalRmseData)&&<LineChart 
              chartData={totalRmseData} 
              xAxisLabel="Round" 
              yAxisLabel="RMSE" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalEpsilonMinData)&&<LineChart 
              chartData={totalEpsilonMinData} 
              xAxisLabel="Round" 
              yAxisLabel="Epsilon Min" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalEpsilonMaxData)&&<LineChart 
              chartData={totalEpsilonMaxData} 
              xAxisLabel="Round" 
              yAxisLabel="Epsilon Max" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {!checkChartNull(totalEpsilonAvgData)&&<LineChart 
              chartData={totalEpsilonAvgData} 
              xAxisLabel="Round" 
              yAxisLabel="Epsilon Average" 
              width={totalChartWidth} 
              height="200" 
              color="#066aff"
            />}
            {isTest&&<div className={styles['total-test-wrap']}>
              <div className={styles['total-test-table']}>
                <p>
                  <span>Loss</span>
                  <span>{roundData[testIndex].testResult?.outputs?.loss?.toFixed(3)||"--"}</span>
                </p>
                {modelType=="classification"?
                <p>
                  <span>Accuracy</span>
                  <span>{roundData[testIndex].testResult?.outputs?.accuracy?.toFixed(3)||"--"}</span>
                </p>
                :<><p>
                  <span>MAE</span>
                  <span>{roundData[testIndex].testResult?.outputs?.mae?.toFixed(3)||"--"}</span>
                </p>
                <p>
                  <span>MSE</span>
                  <span>{roundData[testIndex].testResult?.outputs?.mse?.toFixed(3)||"--"}</span>
                </p>
                <p>
                  <span>RMSE</span>
                  <span>{roundData[testIndex].testResult?.outputs?.rmse?.toFixed(3)||"--"}</span>
                </p></>
                }
              </div>
              <span className={styles['total-test-acc-title']}>Test result</span>
            </div>}
            {/* { isTest && <div className={styles['total-test-acc']}>
            <span className={styles['total-test-acc-body']}> 
              {roundData[testIndex].testResult==null ? 
              "--" : roundData[testIndex].testResult.accuracy||"Invalid"
              }
              </span>
              <span className={styles['total-test-acc-title']}>Test Accuracy</span>
            </div>} */}
            </div>
            {toggleTotalboardMenu==1 &&
            <div className={styles["totalBoard-body-config"]}>
            {taskData.createdTime && <>
            <div className={styles["body-config-wrap"]}>
              <span>Task ID</span>
              <span>{taskData.taskId}</span>
            </div>
            <div className={styles["body-config-wrap"]}>
              <span>Create Time</span>
              <span>{dateFormat(taskData.createdTime).date}</span>
            </div>
            <div className={styles["body-config-wrap"]}>
              <span>Last Time</span>
              <span>{dateFormat(taskData.updatedTime).date}</span>
            </div>
            <div className={styles["body-config-wrap"]}>
              <span>DeviceQuery</span>
              <span>{taskData.deviceQuery}</span>
            </div>
            </>}
            {taskData && 
            Object.entries(taskData.recipe).map(([key,value])=>
            key!="initialModelId" && 
            <div className={styles["body-config-wrap"]}>
            <span>{key}</span>
            <span>{value}</span>
            </div>)
            }
            </div>
            }
            {isConfigModal&&<Portal>
              <div className={styles['modal-config-wrap']} onClick={handleModalOutside}>
                  <div className={styles['modal-config-main']}>
                    <div className={styles['modal-config-head']}>
                      <span>Task Configuration</span>
                      <div className={styles['modal-config-close']} onClick={()=>setIsConfigModal(false)}></div>
                    </div>
                    <div className={styles['modal-config-body']}>
                    {taskData && <>
                    <div className={styles["body-config-wrap"]}>
                      <span>Task ID</span>
                      <span>{taskData.taskId}</span>
                    </div>
                    <div className={styles["body-config-wrap"]}>
                      <span>Create Time</span>
                      <span>{dateFormat(taskData.createdTime).date}</span>
                    </div>
                    <div className={styles["body-config-wrap"]}>
                      <span>Last Time</span>
                      <span>{dateFormat(taskData.updatedTime).date}</span>
                    </div>
                    <div className={styles["body-config-wrap"]}>
                      <span>DeviceQuery</span>
                      <span>{taskData.deviceQuery}</span>
                    </div>
                    </>}
                    {taskData && 
                    Object.entries(taskData.recipe).map(([key,value])=>
                    key!="initialModelId" && 
                    <div className={styles["body-config-wrap"]}>
                    <span>{key}</span>
                    <span>{value}</span>
                    </div>)
                    }
                    </div>
                  </div>
              </div>
            </Portal>}
         </div>
          <div className={styles["TaskDetail-roundBoard"]}>
            <div className={styles["totalBoard-header"]}>
              <span>{roundOn==testIndex?"Test ":roundOn +" Round "}Dashboard</span>
              {roundOn!=testIndex&&
              <div className={`${styles["totalBoard-header-menu"]} ${styles["roundBoard-header-menu"]}`}>
                <div className={`${styles["totalBoard-header-border"]} ${toggleRoundboardMenu == 0 ? styles["roundBoard-header-border-left"] : toggleRoundboardMenu == 1 ?styles["roundBoard-header-border-center"]:styles["roundBoard-header-border-right"]}`}></div>
                <span className={`${styles["totalBoard-header-menu-span"]} ${toggleRoundboardMenu==0 && styles["totalBoard-header-menu-on"]}`} onClick={()=>{setToggleRoundBoardMenu(0)}}>Training</span>
                <span className={`${styles["totalBoard-header-menu-span"]} ${toggleRoundboardMenu==1 && styles["totalBoard-header-menu-on"]}`} onClick={()=>{setToggleRoundBoardMenu(1)}}>Evaluation</span>
              </div>
              }
            </div>
            <div className={`${styles['roundBoard-test-wrap']} ${toggleRoundboardMenu==0?styles['roundBoard-score-train']:styles['roundBoard-score-eval']}`}>
              <div className={`
              ${styles['roundBoard-test-table']}
              ${(modelType==="classification"||toggleRoundboardMenu==0)&&styles['roundBoard-test-table-big']}`}>
              {(isTest&&roundOn===testIndex)&&
                <>
                  <p>
                    <span>Loss</span>
                    <span>{roundData[roundOn].testResult?.outputs?.loss?.toFixed(3)||"--"}</span>
                  </p>
                  {modelType==="classification"?
                  <p>
                    <span>Accuracy</span>
                    <span>{roundData[roundOn].testResult?.outputs?.accuracy?.toFixed(3)||"--"}</span>
                  </p>
                  :<>
                    <p>
                      <span>MAE</span>
                      <span>{roundData[roundOn].testResult?.outputs?.mae?.toFixed(3)||"--"}</span>
                    </p>
                    <p>
                      <span>MSE</span>
                      <span>{roundData[roundOn].testResult?.outputs?.mse?.toFixed(3)||"--"}</span>
                    </p>
                    <p>
                      <span>RMSE</span>
                      <span>{roundData[roundOn].testResult?.outputs?.rmse?.toFixed(3)||"--"}</span>
                    </p>
                  </>}
                </>
                }
                {(roundDataLoading&&roundOn!==testIndex)&&
                <>
                {toggleRoundboardMenu==0?
                  <>
                  <p>
                    <span>Loss</span>
                    <span>{roundData[roundOn].trainingResult?.outputs?.loss?.toFixed(3)||"--"}</span>
                  </p>
                  <p>
                    <span>Epsilon Max</span>
                    <span>{roundData[roundOn].trainingResult?.epsilon?.max.toFixed(3)||"--"}</span>
                  </p>
                  <p>
                    <span>Epsilon Average</span>
                    <span>{roundData[roundOn].trainingResult?.epsilon?.avg.toFixed(3)||"--"}</span>
                  </p>
                  </>
                  :
                  <><p>
                    <span>Loss</span>
                    <span>{roundData[roundOn].evaluationResult?.outputs?.loss?.toFixed(3)||"--"}</span>
                  </p>
                  {modelType=="classification"?
                  <p>
                    <span>Accuracy</span>
                    <span>{roundData[roundOn].evaluationResult?.outputs?.accuracy?.toFixed(3)||"--"}</span>
                  </p>
                  :<><p>
                    <span>MAE</span>
                    <span>{roundData[roundOn].evaluationResult?.outputs?.mae?.toFixed(3)||"--"}</span>
                  </p>
                  <p>
                    <span>MSE</span>
                    <span>{roundData[roundOn].evaluationResult?.outputs?.mse?.toFixed(3)||"--"}</span>
                  </p>
                  <p>
                    <span>RMSE</span>
                    <span>{roundData[roundOn].evaluationResult?.outputs?.rmse?.toFixed(3)||"--"}</span>
                  </p></>
                  }

                  </>
                }</>}
              </div>
              {/* <span className={styles['total-test-acc-title']}>Test result</span> */}
            </div>
            {toggleRoundboardMenu!=2?<>
            {/* {roundOn!=testIndex&&<div className={styles["roundBoard-score"]}>
              {toggleRoundboardMenu==0 ?
              <div className={styles["roundBoard-score-train"]}>
              <span>Loss </span>
              { roundDataLoading && 
              <span>{roundData[roundOn].trainingResult==null ? 
              "--" : Object.entries(roundData[roundOn].trainingResult).length==0?
              "Invalid":roundData[roundOn].trainingResult.loss}
              </span>}
              </div>:
              <div className={styles["roundBoard-score-eval"]}>
              <span>Accuracy </span>
              <span>{ roundDataLoading && 
              <span>{roundData[roundOn].evaluationResult==null ? 
              "--" : Object.entries(roundData[roundOn].evaluationResult).length==0?
              "Invalid":roundData[roundOn].evaluationResult.accuracy}
              </span>}</span>
              </div>}
            </div>
            } */}
            {/* <div className={styles["roundBoard-response"]}> */}
              {/* <span>Device Response</span>
              <div className={styles["response-body"]}>
                <LineChartResponse 
                data={responseData} 
                xAxisLabel="Time" 
                yAxisLabel="Response" 
                width="600" 
                height="200" 
                color="rgba(67, 67, 67, 0.8)"
                />
                <div className={styles["response-count"]}>
                  <span>Target Device Per Round</span>
                  <span>80</span>
                  <span>Target Response Per Round</span>
                  <span>30 / 50</span>
                </div>
              </div> */}
            {/* </div> */}
            {modelType=="classification"&&(toggleRoundboardMenu===1||(roundOn===testIndex))&&confusionData&&
            <div className={styles["roundBoard-heatmap"]}>
              <div className={styles["heatmap-header"]}>
                <span>Confusion Matrix</span>
                <div className={styles['confusion-download']} onClick={handleConfusionDownload}>
                  <BtnWithTip 
                  className={styles["confusion-download-tip"]} 
                  defaultText={"Confusion Data Download"}
                  changeText={isConfusionDownload&&"Download Start"}
                  pos='right'
                  />
                </div>
              </div>
              <HeatmapConfusion width="880" height="480" data={confusionData}/>
            </div>
            }
            <div className={styles["roundBoard-heatmap"]}>
              <div className={styles["heatmap-header"]}>
                <span>Participating Devices Status</span>
              </div>
              <div className={styles["participate-body"]}>
                {donutData&&
                  <DonutChart
                  data={donutData} width={300} height={300}/>
                }
                <div className={styles["participate-info"]}>
                  {donutData && Object.entries(DEVICE_STATE_COLOR)
                  .map((item)=>donutData.find(deviceItem => deviceItem.status===item[0])&&
                    <ParticipateRow 
                    title={item[0]} 
                    devices={donutData.find(deviceItem => deviceItem.status===item[0]).value} 
                    percent={(donutData.find(deviceItem => deviceItem.status===item[0]).value
                      /donutData.reduce((acc,obj)=>acc+obj.value,0) * 100).toFixed(2)} 
                    color={DEVICE_STATE_COLOR[item[0]]}/>
                  )}
                </div>
              </div>
            </div>
            {/* <div className={styles["roundBoard-agg"]}>
              <span>Aggregation Model</span>
              <div className={styles["agg-body"]}>
              </div>
            </div>  */}
            </>
        :<div>
          {/* {deviceData.map((item)=>
          <div className={styles["device-list"]}>
            <span>{item.deviceId}</span>
            <span>{item.deviceState}</span>
          </div>
          )} */}
        </div>}
          </div>
        </div>
      </div>
      </>
  );
}
